import { DateTime } from 'luxon';
import { IIstatRegione } from '../istat-regioni/istat-regioni.model';
import { IIstatComune } from '../istat-comuni/istat-comuni.model';
import { IPuntoCampionamentoTipologia } from '../punti-campionamento-tipologie/punti-campionamento-tipologie.model';
import { IAreraAto } from '../arera-ato/arera-ato.model';
import { IAreraGestore } from '../arera-gestore/arera-gestore.model';
import { IAcquedotto } from '../acquedotti/acquedotti.model';
import { IWaterSupplyZone } from '../water-supply-zone/water-supply-zone.model';
import { statusDefaultIcon, statusDefaultTextColor } from '../controlli/prelievo.config';


export const PRELIEVO_STATUS = ['ok', 'warning', 'alert'] as const;
export type TPrelievoStatus = typeof PRELIEVO_STATUS[number];
export interface IPuntoCampionamento {
  id?: number,
  uuid: string,
  istatRegione: number,
  regione?: IIstatRegione,
  nomeRegione?:string,
  isDateValid?:boolean,
  nomeComune?:string,
  istatComune: number,
  comune?: IIstatComune
  tipoPuntoCampionamento: string,
  puntoCampionamentoTipologia?: IPuntoCampionamentoTipologia,
  idPuntoCampionamento: string,
  idAreraAto: number,
  areraAto?: IAreraAto,
  idAreraGestore: number,
  areraGestore?: IAreraGestore,
  acquedottoId?: number,
  acquedotto?: IAcquedotto,
  progressivoLineAcquedottistica?: string,
  dataInizioValidita?:string,
  dataFineValidita?:string,
  dateStatus?:string,
  isWithinIstatComune?:boolean,
  coordinate?: Array<{
    epsg: string,
    x: number,
    y: number,
    z?: number
  }>,
  coordinateMaps: {
    epsg: string,
    lat: number,
    lon: number,
    z?: number
  },
  coordinateDTO: {
    epsg: string,
    lat: number,
    lon: number,
    z?: number
  },
  previsioneAbitantiServiti?: number,
  previsionePortata?: number,
  descrizionePunto?: string,
  note?: string,
  numeroCampionamentoAnnuoInternoPrevisto: number,
  numeroCampionamentoAnnuoEsterniPrevisto: number,
  wszId?: number,
  wsz?: IWaterSupplyZone,
  createdBy?: number,
  createdDate?: DateTime,
  lastModifiedBy?: number,
  lastModifiedDate?: DateTime,
}

export interface IControlliEffettuati{
  definizione?:string,
  unitaDiMisura?:string,
  dataOraPrelievo?:string,
  valore?:number,
  status: TPrelievoStatus,
}

export interface ICampionamentoExcel {
  uuid: string,
  istatRegione: number,
  istatComune: number,
  tipoPuntoCampionamento: string,
  idPuntoCampionamento: string,
  idAreraAto: number,
  idAreraGestore: number,
  codiceAcquedotto: string,
  wsz: string,
  progressivoLineAcquedottistica?: string,
  EPSG4326_lat: number,
  EPSG4326_lon: number,
  EPSG4326_z?: number,
  previsioneAbitantiServiti?: number,
  previsionePortata?: number,
  descrizionePunto?: string,
  note?: string,
  numeroCampionamentoAnnuoInternoPrevisto: number,
  numeroCampionamentoAnnuoEsterniPrevisto: number,
  dataInizioValidita?:string,
  dataFineValidita?:string,
}

export interface editDateValidita{
  id:number,
  dataInizioValidita: string,
  dataFineValidita: string,
}
export function getStatusIcon(status: TPrelievoStatus): string {
  let icon = statusDefaultIcon[status];
  let textColor = statusDefaultTextColor[status];
  if(icon){
    return `<mat-icon matTooltip="${status}" class="mat-mdc-tooltip-trigger ${textColor} material-symbols-outlined">${icon}</mat-icon>`;
  }else{
    return ''
  }
}